import React from "react";
import { useApp } from "../context/AppContext";
import { Calculator } from "lucide-react";
import { TradePricingEditor } from "../components/pricing/TradePricingEditor";
import { ContractTemplateSettings } from "../components/pricing/ContractTemplateSettings";

export default function TradePricingSettings() {
  const { lang } = useApp();
  const zh = lang === "zh";
  return (
    <div className="space-y-4" data-testid="trade-pricing-page">
      <div>
        <h1 className="text-xl md:text-2xl font-black text-slate-900 flex items-center gap-2"><Calculator className="h-6 w-6 text-slate-700" />{zh ? "工种定价公式" : "Trade pricing formulas"}</h1>
        <p className="text-xs md:text-sm text-slate-500 mt-1 max-w-3xl">{zh ? "自动生成分包合同与 RFQ 参考预算所用的各工种计价方式与参数。根据市场行情随时调整：改完在右侧样例中实时预览，保存即生效并留版本；只影响之后生成的合同/邀请，已生成的不变。" : "Formulas used to auto-generate subcontract budgets and RFQ reference budgets. Changes preview live, save as a version, and only affect future contracts/RFQs."}</p>
      </div>
      <TradePricingEditor />
      <ContractTemplateSettings />
    </div>
  );
}
